export default "__VITE_ASSET__e7cec45c__"